var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gallery",class:{ 'gallery--thumbnail': _vm.displayType === 'thumbnail' }},[(_vm.type === 'wells')?_c('WellsGallery',{attrs:{"images":_vm.images,"thumbnail":_vm.thumbnail,"displayOtherImages":_vm.displayOtherImages,"canOpen":_vm.canOpen}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }